import { createElement } from 'react';
import { Alert } from 'antd';
import { useForm } from '@formily/react';
import { syncUI, useSchema, mergeProperties, reactNode2Schema, useSchemaField, } from '../../shared';
const ObjectContainerPreview = (props) => {
    return createElement("div", Object.assign({}, props), props.children);
};
const FormilyObjectContainer = syncUI((props) => {
    const form = useForm();
    if (!form) {
        return createElement(Alert, { message: "formily component can only be used in formily form", type: "error" });
    }
    if (props.__designMode === 'design') {
        return createElement(ObjectContainerPreview, Object.assign({}, props));
    }
    const schema = useSchema(props);
    const { name } = props.fieldProps;
    const { schema: childrenSchema, componentsNameMap: componentMap } = reactNode2Schema(props.__origin_child || props.children);
    mergeProperties(schema.properties[name], childrenSchema);
    schema.properties[name]['x-component-props'] = undefined;
    const SchemaField = useSchemaField(componentMap);
    return createElement(SchemaField, { schema: schema });
});
export default FormilyObjectContainer;
